import React from "react";
import { useNavigate } from "react-router-dom";
import cardimg from "../../../assets/SC.png";

export default function Form() {
  const navigate = useNavigate();

  const handleNavigation = () => {
    window.scrollTo(0, 0);
    navigate("/contact");
  };

  const handlenav = () => {
    window.location.href = process.env.REACT_APP_BASE_URL;
  };

  return (
    <div
      className="flex flex-col items-center justify-center p-8 h-96 mt-2 md:mt-12"
      style={{ backgroundImage: `url(${cardimg})` }}
    >
      <h1 className="text-2xl sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] text-white mb-8 font-bold text-center lg:px-32">
        Find Any Email with Trusted and Verified <br />
        Results You Can Rely On!
      </h1>
      <div className="text-center w-full flex-col sm:flex-row justify-center sm:space-x-3">
        <button onClick={handlenav} className="font-semibold p-3 rounded-lg bg-white w-[220px]">
          3 Days Risk Free Trial
        </button>
        <button
          onClick={handleNavigation}
          className="font-semibold p-3 rounded-lg border-[1.5px] mt-4 sm:mt-0 border-white text-white bg-[#4976EE] w-[160px]"
        >
          Contact Us
        </button>
      </div>
    </div>
  );
}
